import { z } from "zod";
export const createBookingRequestSchema = z.object({
    message: z.string().trim().max(500).optional().nullable(),
});
export const decideBookingRequestSchema = z.object({
    decisionReason: z.string().trim().max(500).optional().nullable(),
});
//# sourceMappingURL=booking-request.js.map